var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.801 16.9998V14.5998C13.801 12.3374 13.801 11.2054 13.0978 10.503C12.3954 9.7998 11.2634 9.7998 9.00098 9.7998H5.80098C3.53858 9.7998 2.40658 9.7998 1.70418 10.503C1.00098 11.2054 1.00098 12.3374 1.00098 14.5998C1.00098 15.3454 1.00098 15.7182 1.12258 16.0118C1.20299 16.2061 1.32089 16.3826 1.46956 16.5312C1.61822 16.6799 1.79472 16.7978 1.98898 16.8782C2.28258 16.9998 2.65538 16.9998 3.40098 16.9998V10.1998M5.40098 9.7998L7.80098 16.9998",
    stroke: "#EE3224",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40059 14.6H9.40059C9.71885 14.6 10.0241 14.7264 10.2491 14.9515C10.4742 15.1765 10.6006 15.4817 10.6006 15.8C10.6006 16.1183 10.4742 16.4235 10.2491 16.6485C10.0241 16.8736 9.71885 17 9.40059 17H7.80059M10.2006 4.6V3.8C10.2006 3.4323 10.1282 3.0682 9.98745 2.72849C9.84674 2.38877 9.64049 2.08011 9.38048 1.8201C9.12048 1.5601 8.81181 1.35385 8.4721 1.21314C8.13239 1.07242 7.76829 1 7.40059 1C7.03288 1 6.66878 1.07242 6.32907 1.21314C5.98936 1.35385 5.68069 1.5601 5.42069 1.8201C5.16068 2.08011 4.95444 2.38877 4.81372 2.72849C4.67301 3.0682 4.60059 3.4323 4.60059 3.8V4.6C4.60059 4.9677 4.67301 5.3318 4.81372 5.67151C4.95444 6.01123 5.16068 6.31989 5.42069 6.5799C5.68069 6.8399 5.98936 7.04615 6.32907 7.18686C6.66878 7.32758 7.03288 7.4 7.40059 7.4C7.76829 7.4 8.13239 7.32758 8.4721 7.18686C8.81181 7.04615 9.12048 6.8399 9.38048 6.5799C9.64049 6.31989 9.84674 6.01123 9.98745 5.67151C10.1282 5.3318 10.2006 4.9677 10.2006 4.6Z",
    stroke: "#EE3224",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientExperience);
export default __webpack_public_path__ + "static/media/PatientExperience.6d20d4701ae7c03d4decd267bfec1276.svg";
export { ForwardRef as ReactComponent };